import { components } from "@certn/api/generated-schemas/client-portal";
import { Link, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

import { joinNameParts } from "../../pages/group-overview/utils";

type LinkedCase = {
  short_id: string;
  invite_email_address: string;
  applicant_name: components["schemas"]["LinkedCaseApplicantName"];
};

export function LinkedCaseItem({
  linkedCase,
  linkedCaseNumber,
}: {
  linkedCase: LinkedCase;
  linkedCaseNumber?: number;
}) {
  const { t } = useTranslation();

  return (
    <div data-testid="linked-case-item">
      <Text style="global/heading-small">
        <Trans>Co-applicant</Trans> {linkedCaseNumber}
      </Text>
      <div className={styles.linkedCaseItem}>
        <Text style="global/body-secondary">
          {joinNameParts(linkedCase.applicant_name) ||
            linkedCase.invite_email_address}
        </Text>
        <Text style="global/body-secondary">-</Text>
        <Link
          aria-label={t("View case for co-applicant")}
          linkStyle="monochrome"
          textColor="text-weak"
          href={`/case-details/${linkedCase.short_id}`}
          testID="linked-case-link"
          target="_blank"
          textStyle="global/body-secondary"
        >
          {linkedCase.short_id.replaceAll("_", "-")}
        </Link>
      </div>
    </div>
  );
}

const styles = {
  linkedCaseItem: css({
    display: "flex",
    flexWrap: "wrap",
    columnGap: "var(--space-1)",
  }),
};
